// src/pages/Home.js
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Home.css";

// ✅ Update this path to your actual hero image:
import homeImage from "../assets/home.jpg"; // e.g. /src/assets/hero-probioma.jpg

export default function Home() {
  return (
    <section className="hero">
      <Container>
        <Row className="align-items-center">
          {/* Left: Text */}
          <Col lg={6} className="mb-4 mb-lg-0">
            <p className="hero__eyebrow">Probioma</p>

            <h1 className="hero__title">
              Fabrika ku lind një stil jete 🌿
            </h1>

            <p className="hero__subtitle">
              Më shumë se prodhim. Krijojmë pije artizanale që frymëzojnë
              shëndet dhe vetëdije.
            </p>

            <p className="hero__body">
              Probioma është fabrika shqiptare që sjell një koncept të ri:
              pije artizanale të prodhuara me kujdes, nga përbërës natyralë,
              për ata që kërkojnë jo vetëm freski, por një mënyrë jetese më të
              vetëdijshme. Nga Kombucha te Klorofili, Spirulina dhe Ginger
              Beer — çdo produkt është pjesë e një filozofie që bashkon
              shëndetin, energjinë dhe autenticitetin.
            </p>

            <div className="hero__cta">
              <a className="btn-cta" href="/shop">Eksploro Produktet</a>
            </div>
          </Col>

          {/* Right: Image */}
          <Col lg={6} className="text-center text-lg-start">
            <img
              src={homeImage}
              alt="Pije artizanale Probioma në gota me akull dhe erëza"
              className="hero__image"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}
